module.exports = __webpack_public_path__ + "img/huodng21.be9df566.png";